import {plainJSTranslator} from "../../common/PlainJSTranslator";
import {messages} from "../common/Translations";

export const validateGalleryImage = values => {
    let errors = {};
    let length = 130;

    if (values.description.length > length) {
        errors.description =  plainJSTranslator.formatMessage(messages.validationErrorLengthToLong, {length})
    }

    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/galleries/validateGalleryImage.js